import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMoreTooltip: {
		id: 'issue-field-checkbox-select-readview-full.checkbox-select.truncated.show-more-tooltip',
		defaultMessage: 'See more items',
		description: 'Label for trigger button to open a dialog with a list of items',
	},
});
